import { render } from "./data-entry.vue?vue&type=template&id=28f67a41&scoped=true&ts=true"
import script from "./data-entry.vue?vue&type=script&lang=ts"
export * from "./data-entry.vue?vue&type=script&lang=ts"

import "./data-entry.vue?vue&type=style&index=0&id=28f67a41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f67a41"]])

export default __exports__